export const environment = {
  version: 'release-kw42',
  buildDate: '202610151300',
  environment: 'release-kw42',
  release: 'dee00832a6f4770cc10e639c824bae615b33d228',
  production: false,
  debug: true,
  baseUrl: 'https://release-kw42.leads.catch-talents.dev',
  apiUrl: 'https://release-kw42.api.catch-talents.dev',
  apiUrlFallback: 'https://develop.api.catch-talents.dev',
  companyBaseUrl: 'https://release-kw42.company-tool.catch-talents.dev',
  jobboardBaseUrl: 'https://release-kw42.jobboard.catch-talents.dev',
};
